import { render, staticRenderFns } from "./WorkflowRelationFrom.vue?vue&type=template&id=795a74b2&scoped=true"
import script from "./WorkflowRelationFrom.vue?vue&type=script&lang=js"
export * from "./WorkflowRelationFrom.vue?vue&type=script&lang=js"
import style0 from "./WorkflowRelationFrom.vue?vue&type=style&index=0&id=795a74b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795a74b2",
  null
  
)

export default component.exports